"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hiddenContentStyle = {
    position: 'absolute',
    width: 1,
    height: 1,
    margin: -1,
    padding: 0,
    border: 0,
    overflow: 'hidden'
};
//# sourceMappingURL=hiddenContentStyle.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@uifabric/styling/lib/styles/hiddenContentStyle.js
// module id = 988
// module chunks = 0